// Libs
import React, { useEffect } from 'react';
import { useTheme } from '@material-ui/core/styles';

// Hooks
import { useDispatch, useSelector } from 'react-redux';
import useLayout from 'UTILS/hooks/useLayout';

// Components
import Box from '@material-ui/core/Box';
import Intro from 'COMPONENTS/Intro';
import Header from 'COMPONENTS/Header';
import PermissionsInfo from 'COMPONENTS/PermissionsInfo';
import Diagnostics from 'COMPONENTS/Diagnostics';
import Summary from 'COMPONENTS/Summary';

// Actions
import { init, layoutChange } from 'REDUCERS/appSlice';

// Utils
import {
  DIAGNOSTICS_PAGE,
  INTRO_PAGE,
  MOBILE_MAX_WIDTH,
  NARROW_LAYOUT,
  PERMISSIONS_INFO_PAGE,
  SUMMARY_PAGE,
  TONE_AUDIO_ID,
  WIDE_LAYOUT,
} from 'UTILS/constants';

const App = () => {
  const dispatch = useDispatch();
  const theme = useTheme();

  useEffect(() => {
    dispatch(init());
  }, []);

  const isSmallScreen = useLayout({ current: window.document.body }, MOBILE_MAX_WIDTH);
  useEffect(() => {
    dispatch(layoutChange({ layout: isSmallScreen ? NARROW_LAYOUT : WIDE_LAYOUT }));
  }, [isSmallScreen]);

  const currentPage = useSelector((state) => state.nav.currentPage);
  const renderCurrentPage = () => {
    switch (currentPage) {
      case INTRO_PAGE:
        return <Intro />;
      case PERMISSIONS_INFO_PAGE:
        return <PermissionsInfo />;
      case DIAGNOSTICS_PAGE:
        return <Diagnostics />;
      case SUMMARY_PAGE:
        return <Summary />;
    }
  };

  return (
    <Box className='app' bgcolor={theme.palette.grey[100]}>
      {currentPage != null && // TODO Display a loader or something in case the permissions were already given
        <Header />
      }
      {renderCurrentPage()}
      <audio className='app-audio' id={TONE_AUDIO_ID} src={theme.assets.audioToneURL} />
    </Box>
  );
};

export default App;
